// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".submenu-wrapper .el-menu--popup-bottom-start {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.submenu-wrapper .el-menu--popup {\n  min-width: 100px;\n  padding: 0 5px 5px;\n  background-color: #3b3a39;\n}\n.submenu-wrapper .el-menu--popup .el-menu-item {\n  background-color: #3b3a39;\n  color: #fff !important;\n}\n.submenu-wrapper .el-menu--popup .el-menu-item:hover {\n  background-color: #003e8e;\n}\n", ""]);
// Exports
module.exports = exports;
